import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Package } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function CustomerSignup({ setUser }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", password: "", phone: "", country: "Spain",
  });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/customer/signup", form);
      setUser(data);
      toast.success(`Welcome, ${data.name}`);
      navigate("/customer/new");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Sign-up failed");
    } finally {
      setBusy(false);
    }
  };

  const s = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 mb-2">
            <Package size={22} weight="bold" />
            <span className="text-lg font-black tracking-tight">Ronnex Customer Portal</span>
          </div>
          <p className="text-sm text-zinc-500">Create an account to place orders and track your shipments.</p>
        </div>
        <form onSubmit={submit} className="border border-zinc-200 bg-white p-6 space-y-4" data-testid="customer-signup-form">
          <Field label="Full name">
            <Input required value={form.name} onChange={s("name")} data-testid="signup-name" />
          </Field>
          <Field label="Email">
            <Input type="email" required value={form.email} onChange={s("email")} data-testid="signup-email" />
          </Field>
          <Field label="Phone">
            <Input value={form.phone} onChange={s("phone")} placeholder="+34 …" data-testid="signup-phone" />
          </Field>
          <Field label="Country">
            <Input value={form.country} onChange={s("country")} data-testid="signup-country" />
          </Field>
          <Field label="Password (min 8 characters)">
            <Input type="password" required minLength={8} value={form.password} onChange={s("password")} data-testid="signup-password" />
          </Field>
          <Button type="submit" disabled={busy} className="w-full bg-zinc-900 hover:bg-zinc-800 text-white" data-testid="signup-submit">
            {busy ? "Creating account…" : "Create account"}
          </Button>
          <p className="text-xs text-center text-zinc-500">
            Already have an account?{" "}
            <Link to="/customer/login" className="text-zinc-900 font-semibold hover:underline">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold">{label}</Label>
      <div className="mt-1">{children}</div>
    </div>
  );
}
